export const navBarItems = [
  { _id: "1", title: "About", link: "about" },
  { _id: "2", title: "Skills", link: "skills" },
  { _id: "3", title: "Experience", link: "experience" },
  { _id: "4", title: "Projects", link: "projects" },
  { _id: "5", title: "Certificates", link: "certificates" },
  { _id: "6", title: "Contact", link: "contact" },
];
